import {
	REFRESH_POSITION_FILTER,
	SET_POSITION_FILTER,
} from './types'

const initialState = {
	options: [],
	refresh: false,
	initialize: true
};

const reducer = (state = initialState, {type, payload}) => {

	switch (type) {

		case REFRESH_POSITION_FILTER:
			return {
				...state,
				refresh: true,
				initialize: true,
				options: [],
			}
		
		case SET_POSITION_FILTER:
			return {
				...state,
				refresh: false,
				initialize: false,
				options: payload
			}

		default:
			return state;

	}

}

export default reducer